export enum FeatureFlag {
    IS_CHAIN_BOOKING_ENABLED_FOR_PATIENTS = 'isChainBookingEnabledForPatients',
}

export const FEATURE_FLAG_DEFAULTS: Record<FeatureFlag, boolean> = {
    [FeatureFlag.IS_CHAIN_BOOKING_ENABLED_FOR_PATIENTS]: false,
};
